import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Modal,
  Popover,
  TextareaAutosize,
  IconButton,
  InputBase,
  Paper,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery } from "react-query";
import MessagePicker from "../message/picker";
import { setChannelThreadMessageReply } from "../../../../redux/actions";
import { getEmojiByCode } from "../util";
import fetcher from "../../../../dataProvider";
import { makeStyles } from "@mui/styles";
import { setRefreshThreadMessages } from "../../../../redux/slices/community";
import { CommonContext } from "../../../../../components/helper/commonContext";
import socketEvents from "../../../../constant/socketEvents";
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import { Picker } from "emoji-mart";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
const useStyles = makeStyles((theme) => ({
  messageContainer: {
    position: "absolute",
    width: "100%",
    // bottom: "50px",
    top: "0px",
    right: "0px",
    "& button:focus": {
      outline: "none !important",
    },
  },
  iconSmily: {
    left: "20px",
  },
  iconSend: {
    right: "20px",
  },
  replyBox: {
    position: "relative",
    display: "block",
    padding: "5px 15px",
    background: "#f0f1f3",
    "& textarea": {
      background: "#fff !important",
    },
  },
  previewbox: {
    position: "relative",
    display: "flex",
    alignItems: "flex-start",
    background: "#efefef",
    height: "205px",
    padding: "20px",
    "& img": {
      maxWidth: "184px",
      maxHeight: "184px",
      borderRadius: "6px",
      border: "12px solid #CFD0D0",
      objectFit: "cover",
    },
    "& img:last-child": {
      position: "absolute",
      borderRadius: "6px",
      border: "none",
      width: "20px",
      height: "20px",
      cursor: "pointer",
      right: "56%",
      top: "30px",
      objectFit: "cover",
    },
  },
  uploadicon: {
    position: "absolute",
    width: "30px",
    height: "30px",
    lineHeight: "20px",
    bottom: "10px",
    left: "7px",
    // background: "#6f7070",
    borderRadius: "50%",
    zIndex: "25",
    padding: "1px",
    "& button": {
      border: "none",
      background: "none",
      cursor: "pointer",
    },
  },
  uploadcontainer: {
    position: "relative",
    background: "#fff",
    padding: "10px",
    border: "3px solid #ccc",
    borderRadius: "5px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "178px",
    height: "46px",
    margin: "0",
    transition: "0.5s",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "400",
    color: "#E14084",
    "& img": {
      width: "25px",
      marginRight: "15px",
      height: "25px",
    },
  },
  alertPopupdefaultFileType: {
    background: "#19132A",
    width: "100%",
    maxWidth: "576px",
    height: "121px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "white",
    position: "fixed",
    top: "100px",
    left: "50%",
    transform: "translateX(-50%)",
    borderRadius: "24px",
    padding: "0 30px",
    zIndex: 1100,
    "@media(max-width:767px)": {
      width: "90%",
    },
  },
  alertMessage: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    width: "100%",
  },
  content: {
    marginLeft: "10px !important",
    fontSize: "18px",
  },
  gifpickerCSS: {
    right: "25px",
  },
  container: {
    display: "flex",
    height: "200px",
    width: "100%",
    overflow: "auto",
    background: "#444444",
  },
  column: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "3px",
    rowGap: "5px",
  },
  imgContainer: {
    position: "relative",
    color: "white",
  },
  imgText: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: "3",
    fontSize: "24px",
  },
  img: {
    width: "100%",
    height: "auto",
  },
  gif: {
    width: "100%",
    height: "auto",
    filter: "brightness(80%)",
    cursor: "pointer",
    "&:hover": {
      width: "100.2%",
      filter: "brightness(40%)",
      border: "1.5px solid #dd3f93",
    },
  },
  gifSub: {
    width: "100%",
    height: "auto",
    cursor: "pointer",

    "&:hover": {
      width: "100.2%",
      filter: "brightness(100%)",
      border: "1.5px solid #dd3f93",
    },
  },
}));
const ThreadMessageBox = ({ threadId = null }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [message, setMessage] = useState("");
  const [cursorPosition, setCursorPosition] = useState(0);
  const { replyTo1 } = useSelector((state) => state.community);
  const [currentChannel, setCurrentChannel] = useState(null);
  const commonContext = useContext(CommonContext);
  const socket = commonContext.socket;
  const [uploadFileview, setUploadFileview] = useState();
  const [successModal, setSuccessModal] = useState(false);
  const { userData } = useSelector((state) => state.user);
  const [previewImgVIdeoFile, setPreviewImgVIdeoFile] = useState();
  const [previewVideoFile, setPreviewVideoFile] = useState();

  const [showEmojipicker, setShowEmojiPicker] = useState(false);
  const [showGifpicker, setShowGifpicker] = useState(false);
  const [isCategories, setIsCategories] = useState(true);
  const [title, setTitle] = useState("All");
  const [gifCategoryEven, setGifCategoryEven] = useState([]);
  const [gifCategoryOdd, setGifCategoryOdd] = useState([]);
  const [gifListOdd, setGifListOdd] = useState([]);
  const [gifListEven, setGifListEven] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);

  // const replyThreadMessageState = useSelector(
  //   (state) => state.community.replyTo1
  // );
  const currentChannelCommunityState = useSelector(
    (state) => state.community.currentChannel
  );

  const { mutate: postMessage } = useMutation((data) => {
    if (socket != null && socket.connected) {
      console.log(
        "socket Inside send Message thread\ndata : ",
        data,
        "\nsocket : ",
        socket.id,
        socket.connected
      );
      socket.emit(socketEvents.SEND_THREAD_MESSAGE, data, (response) => {
        if (response.status == "success") {
          setMessage("");
          setCursorPosition(0);
          dispatch(setChannelThreadMessageReply(null));
          // dispatch(setRefreshThreadMessages(true));
        } else if (response.status == "failed") {
          // Error While sending message;
        }
        console.log("socket send message response : ", response);
      });
    }
    // Add the respective tag manager data
    else {
      console.log(
        "Socket send message failed ",
        socket == null ? socket : socket?.id,
        socket == null ? socket : socket.connected
      );
    }
  });

  useEffect(() => {
    if (currentChannelCommunityState) {
      setCurrentChannel(currentChannelCommunityState);
    }
  }, [currentChannelCommunityState]);

  const submitMessag = (data) => {
    postMessage(data);
  };

  const handleSend = (e) => {
    if (message.trim()?.length > 0) {
      let _data = {
        type: "text",
        text: message,
        channelId: currentChannel._id,
      };
      if (threadId) {
        _data.threadId = threadId;
      }
      if (replyTo1) {
        _data.parentId = replyTo1._id;
      }

      submitMessag(_data);
      setShowEmojiPicker(false);
      setShowGifpicker(false);
    }
  };

  const onSelectEmoji = (e) => {
    let emoji = getEmojiByCode(e);
    let val = [
      message?.slice(0, cursorPosition),
      emoji,
      message?.slice(cursorPosition),
    ]?.join("");
    setCursorPosition(cursorPosition + emoji.toString().length);
    setMessage(val);
  };
  const onSelectGif = (e) => {
    let _data = {
      type: "gif",
      text: e,
      channelId: currentChannel._id,
    };
    if (threadId) {
      _data.threadId = threadId;
    }
    if (replyTo1) {
      _data.parentId = replyTo1._id;
    }
    submitMessag(_data);
  };

  const [openCommunityuploadpopup, setOpenCommunityuploadpopup] =
    useState(false);
  const handleClose2 = () => {
    setOpenCommunityuploadpopup(false);
  };
  const handleOpen2 = () => {
    setOpenCommunityuploadpopup(true);
  };

  // convert image base64
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  // upload and preview API
  const { mutate: UploadImgandVideoFile } = useMutation(
    (data) => fetcher.post(`/v1/message/upload-attachment`, data),
    {
      onSuccess: (response) => {
        setUploadFileview(response?.data);
      },
      onError: (error) => {
        console.log("error: ", error);
        setUploadFileview("");
      },
    }
  );

  const handleVideoandImageSelected = async (e) => {
    var picture = e.target?.files[0];
    const imageconvertbase64 = await convertBase64(picture);

    const formData = new FormData();
    formData.append("file", picture);
    UploadImgandVideoFile(formData);

    if (picture?.type?.substring(0, 5) === "image") {
      setPreviewImgVIdeoFile(imageconvertbase64);
    } else if (picture?.type?.includes("video")) {
      setPreviewVideoFile(picture);
    } else {
      setSuccessModal(true);
    }
    setOpenCommunityuploadpopup(false);
  };

  const { mutate: threadMessageUploadFile } = useMutation(
    (data) => fetcher.post(`/v1/message`, data),
    {
      onSuccess: (response) => {
        setUploadFileview();
        setMessage("");
      },
      onError: (error) => {
        console.log("error: ", error);
      },
    }
  );

  const handleEnter = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      let data = {
        type: "text",
        text: message,
        channelId: currentChannel?._id,
        threadId: threadId,
      };
      setMessage(e.target.value);
      setCursorPosition(e.target.selectionEnd);
      e.preventDefault();
      if (uploadFileview) {
        // Api call of create message, to upload file.
        data.attachments = uploadFileview;
        threadMessageUploadFile(data);
      } else {
        // Send the messsage through socket, as upload file is not there in sockets
        handleSend();
      }
    }
  };

  // select emoji in thread
  const closeEmoji = () => {
    setShowEmojiPicker(false);
    setOpen(false);
    setAnchorEl(null);
  };

  const handleSelect = (e) => {
    onSelectEmoji(e);
    if (true) {
      closeEmoji();
    }
  };

  // sticker gif picker
  const { data: gifCategoryData } = useQuery(`gifs/categories`, () =>
    fetcher.get(`/v1/gifs/categories`)
  );
  const { mutate: getGifByTag } = useMutation((tag) =>
    fetcher.get(
      `/v1/gifs/search?tag=${encodeURIComponent(tag)}&limit=100&pos=1`
    )
  );

  const openGifPicker = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };
  const closeGifPicker = () => {
    setAnchorEl(null);
    setTitle("All");
    setOpen(false);
    setIsCategories(true);
    setShowGifpicker(false);
  };

  useEffect(() => {
    if (
      gifCategoryData &&
      gifCategoryData.tags &&
      gifCategoryData.tags.length > 0
    ) {
      var _cat = gifCategoryData.tags;
      let evenArray = _cat.filter((a, i) => i % 2);
      let oddArray = _cat.filter((a, i) => !(i % 2));
      setGifCategoryEven(evenArray);
      setGifCategoryOdd(oddArray);
    }
  }, [gifCategoryData]);

  const getByTag = (tag) => {
    setIsCategories(false);
    setTitle(tag.toString());
    getGifByTag(tag, {
      onSuccess: (res) => {
        let evenArray = res.results.filter((a, i) => i % 2);
        let oddArray = res.results.filter((a, i) => !(i % 2));
        setGifListEven(evenArray);
        setGifListOdd(oddArray);
      },
    });
  };

  const GifCategoryDisplay = ({ classes, data, getByTag }) => {
    return (
      <>
        {data?.map((item, index) => (
          <div
            key={index}
            onClick={() => getByTag(item.searchterm)}
            className={classes.imgContainer}
          >
            <Typography className={classes.imgText} sx={{ p: 2 }}>
              {item.searchterm}
            </Typography>{" "}
            <img
              alt={item.searchterm}
              className={classes.gif}
              src={item.image}
            />
          </div>
        ))}
      </>
    );
  };
  const GifDisplay = ({ classes, data, onSelectGif, closeGifPicker }) => {
    return (
      <>
        s
        {data?.map((item, index) => (
          <div key={index} className={classes.imgContainer}>
            <img
              onClick={() => {
                onSelectGif(item.media[0].tinygif.url);
                closeGifPicker();
              }}
              className={classes.gifSub}
              src={item.media[0].tinygif.url}
              alt={"GIF image"}
            />
          </div>
        ))}
      </>
    );
  };

  return (
    <div
      className={`message_input message_input_box ${replyTo1 ? "reply" : ""}`}
    >
      {replyTo1 && (
        <div className="reply-box">
          <p>
            Reply To <b>{replyTo1?.user?.name}</b>
          </p>
          <button
            onClick={() => {
              dispatch(setChannelThreadMessageReply(null));
            }}
          >
            X
          </button>
        </div>
      )}
      {uploadFileview && (
        <Box className={classes.previewbox}>
          <Box style={{ display: "inline-block" }}>
            <Box style={{ position: "relative", display: "inline-block" }}>
              {previewImgVIdeoFile ? (
                <img src={previewImgVIdeoFile} alt={previewImgVIdeoFile} />
              ) : (
                <video
                  width="150"
                  height="100"
                  controls
                  style={{ transform: "none" }}
                >
                  <source
                    src={previewImgVIdeoFile}
                    type={previewVideoFile?.type}
                  />
                </video>
              )}
            </Box>
            <img
              src="/images/community/deleteicon.svg"
              onClick={() => setUploadFileview()}
              title="Remove Attachement"
              alt="community deleteicon"
            />
          </Box>
        </Box>
      )}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          position: "relative",
        }}
      >
        {userData?.role == "admin" && (
          <Box className={classes.uploadicon}>
            <PopupState variant="popover">
              {(popupState) => (
                <>
                  <Box {...bindTrigger(popupState)}>
                    <button onClick={handleOpen2} type="button">
                      <img
                        src="/images/community/uploadicon.svg"
                        style={{ width: "20px", height: "20px" }}
                        alt="community uploadicon"
                      />
                    </button>
                  </Box>
                  <Popover
                    {...bindPopover(popupState)}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    open={openCommunityuploadpopup}
                    onClose={handleClose2}
                    id="upload-attachment"
                  >
                    <input
                      type="file"
                      onChange={(e) => handleVideoandImageSelected(e)}
                      id="choose-file"
                      className="d-none"
                    />
                    <label
                      htmlFor="choose-file"
                      className={classes.uploadcontainer}
                    >
                      <img
                        src="/images/community/selectfileIcon.svg"
                        alt="community selectfileIcon"
                      />
                      <div>
                        <h5>Upload a file</h5>
                      </div>
                    </label>
                  </Popover>
                </>
              )}
            </PopupState>
          </Box>
        )}

        <TextareaAutosize
          id="msg_textarea"
          maxRows={7}
          placeholder={
            userData?.role != "admin" &&
            userData?.community_status?.banned === true
              ? "You do not have permission to send messages in read only thread"
              : "Type a comment"
          }
          onChange={(e) => {
            setMessage(e.target.value);
            setCursorPosition(e.target.selectionEnd);
          }}
          onMouseUp={(e) => setCursorPosition(e.target.selectionEnd)}
          onKeyPress={handleEnter}
          value={message}
          ref={inputRef}
          disabled={
            userData?.role != "admin" &&
            (currentChannel?.private ||
              userData?.community_status?.banned === true)
          }
          onClick={() => {
            setShowEmojiPicker(false);
            setShowGifpicker(false);
          }}
        />
        <div className={classes.messageContainer}>
          {/* <MessagePicker
          onSelectEmoji={onSelectEmoji}
          onSelectGif={onSelectGif}
          isEmoji={true}
          isGif={true}
          disabled={currentChannel?.private}
        /> */}
          {/* emoji Picker  */}
          <Box
            component="img"
            src="/images/Smiley.svg"
            width="18"
            height="18"
            style={{
              cursor: "pointer",
              zIndex: "99",
              position: "absolute",
              right: "84px",
              top: "25px",
            }}
            alt="smiley icon"
            onClick={() => {
              setShowEmojiPicker(true);
              setShowGifpicker(false);
            }}
          />
          {/* gif Picker  */}
          <Box
            component="img"
            src="/images/gif.svg"
            width="20"
            height="20"
            style={{
              cursor: "pointer",
              zIndex: "99",
              position: "absolute",
              right: "60px",
              top: "25px",
            }}
            alt="gif icon"
            onClick={() => {
              setShowGifpicker(true);
              setShowEmojiPicker(false);
            }}
          />
          <button
            type="button"
            className={classes.iconSend + " send-btn hint hint-top"}
            aria-label="Send"
            disabled={currentChannel?.private}
            onClick={handleSend}
          >
            {/* <img src="/images/community/create-thread.svg" width="20" style={{marginRight:"5px"}} height="20" /> */}
            <img
              src="/images/send.svg"
              alt="message send"
              style={{
                top: "50%",
                zIndex: "99",
                position: "absolute",
                transform: "translateY(-50%)",
              }}
            />
          </button>
        </div>
      </div>
      <Box className={showEmojipicker ? "emoji_Container" : "emoji-mart-light"}>
        <Picker onSelect={handleSelect} />
      </Box>

      <Box className={showGifpicker ? "emoji_Container" : "emoji-mart-light"}>
        <Paper
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            background: "white",
            border: "1px solid black",
          }}
        >
          {isCategories ? (
            ""
          ) : (
            <IconButton
              color="inherit"
              aria-label="upload sticker"
              component="span"
              onClick={() => {
                setIsCategories(true);
                setTitle("All");
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder={title}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            onKeyDown={(e) => {
              if (e.key == "Enter") {
                getByTag(title);
                e.preventDefault();
              }
            }}
          />
          <IconButton
            onClick={(e) => {
              console.log("onclick");
              getByTag(title);
            }}
            sx={{ p: "10px" }}
            aria-label="search"
          >
            <SearchIcon />
          </IconButton>
        </Paper>
        {isCategories ? (
          <div className={classes.container}>
            <div className={classes.column}>
              <GifCategoryDisplay
                classes={classes}
                data={gifCategoryEven}
                getByTag={getByTag}
              />
            </div>
            <div className={classes.column}>
              <GifCategoryDisplay
                classes={classes}
                data={gifCategoryOdd}
                getByTag={getByTag}
              />
            </div>
          </div>
        ) : (
          <div className={classes.container}>
            <div className={classes.column}>
              <GifDisplay
                classes={classes}
                data={gifListOdd}
                onSelectGif={onSelectGif}
                closeGifPicker={closeGifPicker}
              />
            </div>
            <div className={classes.column}>
              <GifDisplay
                classes={classes}
                data={gifListEven}
                onSelectGif={onSelectGif}
                closeGifPicker={closeGifPicker}
              />
            </div>
          </div>
        )}
      </Box>

      <Modal
        open={successModal}
        onClose={() => {
          setSuccessModal(false);
        }}
      >
        <Box className={classes.alertPopupdefaultFileType}>
          <Box className={classes.alertMessage}>
            <Box
              component="img"
              src="/images/community/erroricon.svg"
              width="20px"
            />
            <Typography variant="span" className={classes.content}>
              Invalid file format, please upload image file in (jpeg,png).
            </Typography>
          </Box>

          <Box
            onClick={() => {
              setSuccessModal(false);
            }}
            component="img"
            src="/images/alert/close-icon.svg"
            style={{ cursor: "pointer" }}
            width="20"
          />
        </Box>
      </Modal>
    </div>
  );
};

export default ThreadMessageBox;
